import {
  type AttributionCookie,
  extractUtmSourceFromCookie,
  parseAttributionCookie,
} from "../lib/attribution";

export type ClientAttribution = {
  type: AttributionCookie["k"];
  value: string;
  seenAt: number;
};

function toClientAttribution(cookie: AttributionCookie | null): ClientAttribution | null {
  if (!cookie) {
    return null;
  }

  return {
    type: cookie.k,
    value: cookie.v,
    seenAt: cookie.t,
  };
}

export function getAttribution(): ClientAttribution | null {
  if (typeof document === "undefined") {
    return null;
  }

  const cookie = parseAttributionCookie(document.cookie);
  return toClientAttribution(cookie);
}

export function getUtmSource(): string | null {
  if (typeof document === "undefined") {
    return null;
  }

  return extractUtmSourceFromCookie(document.cookie);
}

function readCookieFromString(cookieString: string): ClientAttribution | null {
  const parsed = parseAttributionCookie(cookieString);
  return toClientAttribution(parsed);
}

// Exposed for testing
export { readCookieFromString };
